import axios from 'axios';

const params = {};
if (process.env.VUE_APP_AWARENESS_API_URL) {
  params.baseURL = process.env.VUE_APP_AWARENESS_API_URL;
}
const instance = axios.create(params);

instance.defaults.xsrfCookieName = process.env.VUE_APP_COOKIE_PREFIX === 'false' ? 'csrftoken' : `${process.env.VUE_APP_COOKIE_PREFIX}csrftoken`;
instance.defaults.xsrfHeaderName = 'X-CSRFToken';
instance.defaults.withCredentials = true;

export default instance;

